import { Icon, React } from '../../../common';
import { visitInput as styles } from '../style';

export const DownArrowIcon = ({ onPress }) => (
    <Icon name="down-arrow" size={20} color="#555555" style={styles.inputIcon} onPress={onPress} />
);
